import React, { useState, useEffect } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Loader2, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function LegalPage() {
  const { pageType: paramPageType } = useParams();
  const location = useLocation();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Determine page type from URL path if not provided as param
  const pageType = paramPageType || (location.pathname === '/sms-terms' ? 'sms_terms' : location.pathname === '/privacy-policy' ? 'privacy_policy' : 'sms_terms');

  useEffect(() => {
    fetchPage();
  }, [pageType]);

  const fetchPage = async () => {
    try {
      const response = await axios.get(`${API_URL}/legal/${pageType}`);
      setPage(response.data);
    } catch (error) {
      console.error('Failed to load page:', error);
      setPage({
        title: 'Page Not Found',
        content: '<p>The requested page could not be found.</p>'
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <Loader2 className="w-8 h-8 animate-spin text-[#9F1239]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      {/* Header */}
      <header className="bg-white border-b border-[#E7E5E4] sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#9F1239] hover:text-[#881337]">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Back to Home</span>
          </Link>
          <span className="font-serif tracking-wide whitespace-nowrap text-lg md:text-xl text-[#1C1917]" data-testid="brand-name">Acqualina Resort</span>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white border border-[#E7E5E4] rounded-sm shadow-sm p-8">
          <h1 className="font-serif text-3xl text-[#1C1917] mb-6">{page?.title}</h1>
          <div 
            className="prose prose-sm max-w-none text-[#44403C]"
            dangerouslySetInnerHTML={{ __html: page?.content || '' }}
          />
          {page?.last_updated && (
            <p className="mt-8 text-sm text-[#78716C]">
              Last updated: {new Date(page.last_updated).toLocaleDateString()}
            </p>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#1C1917] text-white py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-[#78716C]">© 2026 Acqualina Resort. All rights reserved.</p>
          <div className="flex justify-center gap-6 mt-4">
            <Link to="/sms-terms" className="text-sm text-[#78716C] hover:text-white">SMS Terms</Link>
            <Link to="/privacy-policy" className="text-sm text-[#78716C] hover:text-white">Privacy Policy</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
